import { render } from "./Permissions.vue?vue&type=template&id=b3c17b84&ts=true"
import script from "./Permissions.vue?vue&type=script&lang=ts"
export * from "./Permissions.vue?vue&type=script&lang=ts"

import "./Permissions.vue?vue&type=style&index=0&id=b3c17b84&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__